<template>
  <v-container>
    <h1 class="text-h5 mb-4">{{ $t('admin.instructors') || 'Instructor Management' }}</h1>
    <v-alert type="info" variant="tonal">Instructor management UI placeholder.</v-alert>
  </v-container>
</template>

<script setup>
</script>
